var base = require("./home");
import Axios from "axios";
import Console from "../components/console.vue";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import VueGallerySlideshow from 'vue-gallery-slideshow';
import "vue-nav-tabs/themes/vue-tabs.css";

// add stylesheet
require("vue-select-image/dist/vue-select-image.css");

Vue.component("show-task", {
    props: ["user", "task", "cons"],
    components: {
        Axios,
        VueTabs,
        VTab,
        VueGallerySlideshow,
        Console
    },
    data: function() {
        return {
            results:{},
            index: null,
            imgIndex: null,
            console_out: ''
        };
    },
    mounted() {
        console.log(this.task);


    },

    methods: {
        filterResultsByType(results, type) {
            return results.filter(result => result.type === type);

        },
        filterUrlsByType(results, type){
            var filter = results.filter(result => result.type === type);
            var files =[];
            filter.forEach(element => files.push('/result/'+element.id));
            return files;
        },
        async getResult(id) {
            axios.get("/result/" + id, {}).then(response => {
                console.log((response.data));
                return require(response.data);
            });
        },
        

    }


});
